import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createSelector } from '@reduxjs/toolkit';

import { SearchContext } from '.';
import { Sidebar, FolderTree, ResourcesFilter, LoaderWrapper } from '@/components/common';
import { selectFoldersList, selectPendingAction } from '@/store/selectors/resourcesSelectors';
import { getTree } from '@/store/slices/resourcesSlice';
import { useAppSelector } from '@/hooks';
import { SidebarResourcesSkeleton } from './SidebarResources.skeleton';

const sidebarResourcesSelector = createSelector(
  selectFoldersList,
  selectPendingAction(getTree.typePrefix),
  (foldersList, isFetching) => ({
    isReady: !isFetching && foldersList !== null,
  }),
);

const SidebarResources = (): React.ReactElement => {
  const { t } = useTranslation();
  const { isReady } = useAppSelector(sidebarResourcesSelector);
  const [search, setSearch] = useState('');

  return (
    <Sidebar title={t`resources.leftPanel.title`}>
      <SearchContext.Provider value={{ search, setSearch }}>
        <ResourcesFilter />
        <LoaderWrapper isLoading={!isReady} loader={<SidebarResourcesSkeleton />}>
          <FolderTree />
        </LoaderWrapper>
      </SearchContext.Provider>
    </Sidebar>
  );
};

export { SidebarResources };
